import { type ComponentPropsWithRef } from 'react';

import { useMergedRef } from '@/hook';

import { VStack } from '../VStack';
import { joinCn } from '../util';
import VInnerBaseTableTbody from './VInnerBaseTableTbody';
import VInnerBaseTableThead from './VInnerBaseTableThead';
import { useVBaseTableContext } from './hook';
import style from './style';

const VInnerBaseTable = (props: ComponentPropsWithRef<'div'>) => {
  const { $table } = useVBaseTableContext();
  const mergedTableRef = useMergedRef($table as any, props.ref as any);
  const twStyle = style({});

  return (
    <VStack
      {...props}
      ref={mergedTableRef}
      role="table"
      className={joinCn(twStyle.vBaseTable, props.className)}
      data-testid="v-inner-base-table"
    >
      <VInnerBaseTableThead />
      <VInnerBaseTableTbody />
    </VStack>
  );
};

export default VInnerBaseTable;
